import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * 契約情報取得API
 * @param  {} params={}
 */
export const getContract = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/001', r).catch(handleError)
}

/**
 * 契約情報変更API
 * @param  {} params={}
 */
export const updateContract = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/002', r).catch(handleError)
}

/**
 * 利用者取得API
 * @param  {} params={}
 */
export const getUsers = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/003', r).catch(handleError)
}

/**
 * 利用者追加API
 * @param  {} params={}
 */
export const addUser = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/004', r).catch(handleError)
}

/**
 * 利用者更新API
 * @param  {} params={}
 */
export const updateUser = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/005', r).catch(handleError)
}

/**
 * 利用者状態更新
 * @param  {} params={}
 */
export const updateUserStatus = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/012', r).catch(handleError)
}

/**
 * 利用者一括更新
 * @param  {} params={}
 */
export const updateUsersInBulk = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/006', r).catch(handleError)
}

/**
 * 利用者リセットAPI
 * @param  {} params={}
 */
export const resetUser = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/007', r).catch(handleError)
}

/**
 * パッケージ・商品情報取得
 * @param  {} params={}
 */
export const listPackagesAndProducts = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/008', r).catch(handleError)
}

/**
 * 商品申込API
 * @param  {} params={}
 */
export const applyProducts = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/009', r).catch(handleError)
}

/**
 * 申込履歴一覧API
 * @param  {} params={}
 */
export const listApplicationHistory = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/010', r).catch(handleError)
}

/**
 * 契約ライセンス情報取得API
 * @param  {} params={}
 */
export const getContractLicenses = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/011', r).catch(handleError)
}

/**
 * 利用アカウントCSVダウンロード
 * @param  {} params={}
 */
export const getAccountCSV = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const options = {
    ...NEW_API_CONFIG,
    responseType: 'blob'
  }

  const newAxios = axios.create(options)
  return newAxios.post('/AG/013', r).catch(handleError)
}

/**
 * 利用アカウントCSVアップロード
 * @param  {} params={}
 */
export const updateAccountCSV = (file, { id, name, email }) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = new FormData()
  r.append('token', token)
  r.append('organization_id', organizationId)
  r.append('file', file)
  r.append('user_id', id)
  r.append('admin_name', name)
  r.append('admin_email', email)
  r.append('contract_file_upload', true)

  const options = {
    ...NEW_API_CONFIG,
    headers: {
      'content-type': 'multipart/form-data'
    }
  }

  const newAxios = axios.create(options)
  return newAxios.post('/AG/014', r).catch(handleError)
}

/**
 * 商品価格取得
 * @param {Object} params
 * @param {number} params.productId 商品ID
 * @param {number} params.numOfLicenses ライセンス数
 */
export const getProductPrice = ({ productId, numOfLicenses }) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    token: token,
    organization_id: organizationId,
    product_id: productId,
    num_of_licenses: numOfLicenses
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AG/015', r).catch(handleError)
}

/**
 * WEBセッション情報取得API
 * @param  {} params={}
 */
export const getWebSession = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  // 開発環境の場合は、パラメータにmember_paramをベタ書きで付与する
  if (process.env.NODE_ENV === 'development') {
    params.member_param = process.env.VUE_APP_SNH_WEB_MEMBER_PARAM
  }

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/CM/008', r).catch(handleError)
}

/**
 * 申込認証コード取得API
 * @param  {} params={}
 */
export const getOfferCode = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/011', r).catch(handleError)
}

/**
 * WEB会員認証API
 * @param  {} params={}
 */
export const authWebUser = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/008', r).catch(handleError)
}
